var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M140 15c34.463 0 62.5 28.038 62.5 62.5v50c13.788 0 25 11.2 25 25V240c0 13.788-11.212 25-25 25h-125c-13.787 0-25-11.212-25-25v-87.5c0-13.8 11.213-25 25-25v-50C77.5 43.038 105.538 15 140 15m62.5 137.5h-125V240h125.025zm-62.5 25c10.35 0 18.75 8.4 18.75 18.75S150.35 215 140 215s-18.75-8.4-18.75-18.75 8.4-18.75 18.75-18.75M140 40c-20.675 0-37.5 16.825-37.5 37.5v50h75v-50c0-20.675-16.825-37.5-37.5-37.5"
})));
export default SvgLock;